import React, {useRef, useEffect} from 'react'
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import TimeExtensionRequestPic from '../../../../assets/images/time-extension-request.png';

const TimeExtensionRequest = ({showModal, closeModal}) => {
    const modalRef = useRef();
  
    useEffect(() => {
      if (showModal) {
          const modal = new Modal(modalRef.current, {
              backdrop: 'static',
              keyboard: false,
            });
          modal.show();
      }
    }, [showModal]);
  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
         <div className="modal-dialog modal-dialog-centered modal-sm">
             <div className="modal-content">
                <div className="modal-header border-0 pb-0">
                    <h6 className="modal-title text-blue-900">Time extension request</h6>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
                </div>
                <div className="modal-body">
                    <img src={TimeExtensionRequestPic} alt='' />
                    <h2 className='my-6 text-center text-blue-900'>Time extension request</h2>
                    <div className="mb-6">
                        <label htmlFor="reason" className="form-label">Reason</label>
                        <textarea className="form-control" id="reason" rows="3" placeholder='Can I have a 20mins more to play BrawlStars please?'></textarea>
                    </div>
                    <div className='grid gap-3'>
                        <button className='btn btn-outline-primary g-col-6' data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}><span className='btn-upper-case' >reject</span></button>
                        <button className='btn btn-primary g-col-6'><span className='btn-upper-case'>accept</span></button>
                    </div>
                </div>
             </div>
         </div>
     </div>
  )
}

export default TimeExtensionRequest